if ($("footer#footer").length) {
  $("#signature a.title").text("Shoptet Premium");
  $("#signature").prepend('<span class="shopcode">Nakódoval <a href="https://www.shopcode.cz/?utm_source=kodovani&utm_medium=signature&utm_campaign=velkoobchod-salony" target="_blank" >Shopcode</a></span>');
  $("#signature").css("display", "flex");
  $(document).on("click", ".custom-footer > div .tls:not(.mobile)", function () {
    const parent = $(this).closest(".custom-footer > div");
    $(".custom-footer > div").not(parent).removeClass("open");
    parent.toggleClass("open");
  });

  $("body:not(.type-page) footer#footer").before($("#footer .reviewsWrapper"));
  $("footer#footer").before($(".igWrap"));
  $(".instagram-widget>a").each(function () {
    $(".igFeed").append('<div class="igPost"><a href="' + $(this).attr("href") + '" target="_blank" style="background-image: url(' + $(this).find("img").attr("data-src") + ')"></a></div>');
  });

  $(".socials").html("");
  $(".socials").append($("footer#footer .contact-box li span.facebook").closest("li").clone());
  $(".socials").append($("footer#footer .contact-box li span.instagram").closest("li").clone());
  $(".socials").append($("footer#footer .contact-box li span.youtube").closest("li").clone());

  $(".contacts .first.whatsapp span").prepend($("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"));
  $(".contacts").append($("footer#footer .contact-box li span.mail").closest("li").clone().addClass("mail"));
  $('.contacts span.tel')

  $(".contacts .tel a").each(function () {
    const $link = $(this);
    const text = ($link.text() || "").replace(/\s+/g, " ").trim();
    if (!text || !text.startsWith("+420")) return;

    const rest = text.replace(/^\+420\s*/, "");
    $link.html('<span class="tel-prefix">+420</span><span class="tel-number"> ' + rest + "</span>");
  });

  // "Copyright YYYY <strong>Jméno</strong>. Všechna práva vyhrazena." -> "© YYYY Jméno s.r.o. — Všechna práva vyhrazena."
  $(".copyright[data-testid='textCopyright']")
    .contents()
    .each(function () {
      if (this.nodeType !== 3) return;
      this.nodeValue = this.nodeValue
        .replace(/Copyright\s*(\d{4})/, "© $1")
        .replace(/^\.\s*Všechna práva vyhrazena\./, " — Všechna práva vyhrazena.");
    });
}
